import React from "react";
import bgImage from "../assets/programs-bg.webp";
import bgLines from "../assets/programms-bg-lines.webp";
import bgImage2 from "../assets/project-bg2.webp";
import { useSelector } from "react-redux";

const Banner = ({ title, text,parent, setOpen }) => {
  const { userInfo } = useSelector((state) => state?.authSlice);
  const isMobile = window.innerWidth < 768; 
  const background = isMobile ? bgImage2 : bgImage;

  return (
    <div
      className="flex flex-col text-white items-center justify-center md:py-32 py-20 relative font-roboto px-4 bg-cover bg-center"
      style={{ backgroundImage: `url(${background})` }}
    >
      <img
        src={bgLines}
        alt="decorative lines"
        className="absolute bottom-0 right-0 sm:h-1/2 h-[35%] w-auto"
      />
      <h1 className="md:text-4xl text-2xl font-bold mb-3 z-10">{title}</h1>
      <p className="md:text-lg text-base font-normal mx-auto leading-relaxed font-quicksand max-w-7xl text-center z-10">
        {text}
      </p>
      {parent === 'blogs' &&
      (userInfo?.user?.role === "admin" ||
                  userInfo?.user?.role === "medicalstaff") && (
                  <button
                    onClick={() => setOpen(true)}
                    className="primary-button w-max"
                  >
                    Post new blog
                  </button>
                )}
    </div>
  );
};

export default Banner;
